<div class="app flex-row align-items-center bg-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div style="height: 1px"></div>
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <h1 class="font-weight-bold text-muted">パスワード再設定</h1>
              <p class="text-muted mb-4">
                ご登録のメールアドレスと生年月日をご入力ください。<br>
                メールが届かない方は、
                <a href="https://smartfit100.com/shop" target="_blank">
                  <span>各店舗へお問い合わせください。</span>
                  <span class="material-icons-outlined" style="font-size: inherit">open_in_new</span>
                </a>
              </p>
              <form novalidate #myForm="ngForm">
                <div class="input-group mb-4">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa fa-envelope text-white"></i></span>
                  </div>
                  <input type="email" class="form-control" placeholder="登録メールアドレスを入力してください" [(ngModel)]="member.email" name="email" required email>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend d-none d-sm-flex">
                    <span class="input-group-text bg-login-input"><i class="fa fa-birthday-cake text-white"></i></span>
                  </div>
                  <input type="date" class="form-control" placeholder="登録生年月日を入力してください" [(ngModel)]="member.birthday" name="birthday" required>
                </div>
                <div class="row">
                  <div class="col-12 text-right">
                    <button type="button" class="btn btn-primary px-4 text-white" [disabled]="myForm.invalid"
                            data-toggle="modal" data-target="#lineGraphModal">
                      <i class="fa s-icon-reset"></i> 再設定
                    </button>
                  </div>
                </div>
              </form>

              <!-- Modal -->
              <div class="modal fade" id="lineGraphModal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">&nbsp;確認</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <p>
                        マイページパスワード再設定のご案内メールをご登録アドレス宛に送信します。<br>
                        本文中のURLよりパスワードの再設定を行ってください。<br><br>
                        メールアドレス、生年月日がご登録のものと異なっている場合、メールは送信されません。<br>
                        メール不着の際は、店舗に直接お問い合わせください。<br>
                      </p>
                    </div>
                    <div class="modal-footer">
                      <button class="btn bg-close text-white" type="button" data-dismiss="modal"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
                      <button (click)="sendMail()" class="btn btn-primary text-white" data-dismiss="modal"><i class="fa s-icon-reset"></i>&nbsp;実行</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
